<dgx-components-grid-section [themeFlush]="true">
  <dgx-components-grid-container>
    <dgx-components-grid-row>
      <dgx-components-grid-column>
        <div class="breadcrumb-search-bar">
          <dg-smart-fix-hub-breadcrumbs
            [rootLabel]="'Homepage'"
            class="breadcrumb"
          ></dg-smart-fix-hub-breadcrumbs>
          <ng-container>
            <form
              *ngIf="cs.form as form"
              (submitted)="onFormSubmit($event)"
              [formGroup]="cs.form"
              class="search-bar"
              dgxFormSubmit
            >
              <dgx-form-row>
                <dgx-form-field dgxGaFormField formControlName="search">
                  <dgx-form-search-input [placeholder]="'Search'" />
                </dgx-form-field>
              </dgx-form-row>
            </form>
          </ng-container>
        </div>
      </dgx-components-grid-column>
    </dgx-components-grid-row>
  </dgx-components-grid-container>
</dgx-components-grid-section>
